import React, { useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

// Sınıf ve Ünite Yapısı
const educationStructure = [
  {
    grade: '5',
    title: '5. Sınıf Fen Bilimleri',
    color: 'from-blue-500 to-cyan-500',
    icon: 'ri-seedling-line',
    image:
      'https://images.unsplash.com/photo-1532094349884-543bc11b234d?auto=format&fit=crop&q=80&w=800',
    units: [
      {
        id: 1,
        name: 'Gökyüzündeki Komşularımız ve Biz',
        topics: [
          {
            name: '1. Bölüm: Gökyüzündeki Komşumuz: Güneş',
            videoLinks: [
              'https://www.youtube.com/watch?v=example1',
              'https://www.youtube.com/watch?v=example2',
            ],
            summary:
              'Güneş sistemimizde 8 gezegen bulunur. Güneş, sistemin merkezindeki yıldızdır ve tüm gezegenlere ışık ve ısı sağlar.',
            games: [],
            hasQuiz: true,
          },
          {
            name: "2. Bölüm: Gökyüzündeki Komşumuz: Ay",
            videoLinks: ['https://www.youtube.com/watch?v=example3'],
            summary:
              'Dünya kendi etrafında dönerek gece-gündüz oluşumunu, Güneş etrafında dönerek mevsimleri oluşturur.',
            games: [],
            hasQuiz: true,
          },
          {
            name: "3. Bölüm: Dünya’mız ve Gökyüzündeki Komşularımız",
            videoLinks: ['https://www.youtube.com/watch?v=example3'],
            summary:
              'Dünya kendi etrafında dönerek gece-gündüz oluşumunu, Güneş etrafında dönerek mevsimleri oluşturur.',
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 2,
        name: 'Kuvveti Tanıyalım',
        topics: [
          {
            name: '1. Bölüm: Kuvvet ve Kuvvetin Ölçülmesi',
            videoLinks: ['https://www.youtube.com/watch?v=example4'],
            summary:
              'Kuvvet, cisimlerin hareket durumunu değiştiren veya şeklini bozan etkidir. Newton (N) ile ölçülür.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '2. Bölüm: Kütle ve Ağırlık İlişkisi',
            videoLinks: ['https://www.youtube.com/watch?v=example4'],
            summary:
              'Kütle, bir cismin sahip olduğu madde miktarıdır; ağırlık ise o cismin yerçekimi kuvvetidir.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '3. Bölüm: Sürtünme Kuvveti',
            videoLinks: ['https://www.youtube.com/watch?v=example4'],
            summary:
              'Sürtünme, iki yüzeyin temasında ortaya çıkan ve hareket을 방해하는 힘입니다.',
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 3,
        name: 'Canlıların Yapısına Yolculuk',
        topics: [
          {
            name: '1. Bölüm: Hücre ve Organelleri',
            videoLinks: ['https://www.youtube.com/watch?v=example5'],
            summary:
              'Hücre, canlıların en küçük yapı birimidir. Çekirdek, sitoplazma ve hücre zarından oluşur.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '2. Bölüm: Destek ve Hareket Sistemi',
            videoLinks: ['https://www.youtube.com/watch?v=example5'],
            summary:
              'Kas ve iskelet sistemi yaşamı destekler ve hareketi sağlar.',
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 4,
        name: 'Işığın Dünyası',
        topics: [
          {
            name: '1. Bölüm: Işığın Yayılması',
            videoLinks: ['https://www.youtube.com/watch?v=example6'],
            summary: 'Işık doğrusal yayılır, yansır ve kırılır. Işık olmadan göremeyiz.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '2. Bölüm: Işığın Madde İle Etkileşimi',
            videoLinks: ['https://www.youtube.com/watch?v=example6'],
            summary:
              'Işık maddeden geçerken yansıma, kırılma veya emilim gerçekleşir.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '3. Bölüm: Tam Gölgenin Oluşumu',
            videoLinks: ['https://www.youtube.com/watch?v=example6'],
            summary: 'Tam gölge, ışığın tamamen engellendiği bölgede oluşur.',
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 5,
        name: 'Maddenin Doğası',
        topics: [
          {
            name: '1. Bölüm: Maddenin Tanecikli Yapısı',
            videoLinks: ['https://www.youtube.com/watch?v=example5'],
            summary:
              'Maddeler atom ve moleküllerden oluşur; her biri belirli bir kütleye sahiptir.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '2. Bölüm: Isı ve Sıcaklık',
            videoLinks: ['https://www.youtube.com/watch?v=example5'],
            summary:
              'Isı, enerjinin bir formu; sıcaklık ise bir maddenin ısı seviyesini gösteren ölçüdür.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '3. Bölüm: Maddenin Hâl Değişimi',
            videoLinks: ['https://www.youtube.com/watch?v=example5'],
            summary:
              'Isı enerjisiyle madde katı, sıvı, gaz hallerine dönüşebilir.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '4. Bölüm: Madde ve Isı',
            videoLinks: ['https://www.youtube.com/watch?v=example5'],
            summary:
              'Isı, madde içindeki parçacıkların hareket enerjisini artırır.',
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 6,
        name: 'Elektrik Devre Elemanları',
        topics: [
          {
            name: '1. Bölüm: Devre Elemanlarının Sembollerle Gösterimi ve Devre Şemaları',
            videoLinks: ['https://www.youtube.com/watch?v=example5'],
            summary:
              'Resistör, kondansatör gibi elemanlar sembollerle temsil edilir.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '2. Bölüm: Basit Bir Elektrik Devresinde Ampul Parlaklığını Etkileyen Değişkenler',
            videoLinks: ['https://www.youtube.com/watch?v=example5'],
            summary:
              'Gerilim, akım ve direnç, ampulün ışık şiddetini belirler.',
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 7,
        name: 'Sürdürülebilir Yaşam ve Geri Dönüşüm',
        topics: [
          {
            name: '1. Bölüm: Evsel Atıklar ve Geri Dönüşüm',
            videoLinks: ['https://www.youtube.com/watch?v=example5'],
            summary:
              'Atıkların geri dönüştürülmesi doğal kaynakları korur ve çevre kirliliğini azaltır.',
            games: [],
            hasQuiz: true,
          },
        ],
      },
    ],
  },
  {
    grade: '6',
    title: '6. Sınıf Fen Bilimleri',
    color: 'from-emerald-500 to-green-500',
    icon: 'ri-microscope-line',
    image:
      'https://images.unsplash.com/photo-1576086213369-97a306d36557?auto=format&fit=crop&q=80&w=800',
    units: [
      {
        id: 1,
        name: 'Güneş Sistemi ve Tutulmalar',
        topics: [
          {
            name: '1. Bölüm: Güneş Sistemi',
            videoLinks: ['https://www.youtube.com/watch?v=example7'],
            summary:
              'Güneş sistemi sekiz gezegen, Güneş ve diğer gök cisimlerinden oluşur.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '2. Bölüm: Güneş ve Ay Tutulmaları',
            videoLinks: ['https://www.youtube.com/watch?v=example7'],
            summary:
              "Güneş tutulması Ay'ın Güneş ile Dünya arasına girmesiyle, Ay tutulması ise Dünya'nın Ay ile Güneş arasına girmesiyle oluşur.",
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 2,
        name: 'Kuvvetin Etkisinde Hareket',
        topics: [
          {
            name: '1. Bölüm: Bileşke Kuvvet',
            videoLinks: ['https://www.youtube.com/watch?v=example8'],
            summary:
              'Bileşke kuvvet, birden çok kuvvetin bir vektör olarak birleşmesidir.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '2. Bölüm: Sabit Hızlı ve Sabit İvmeli Hareket',
            videoLinks: ['https://www.youtube.com/watch?v=example8'],
            summary:
              'Sabıt hızda hareket eden cisimlerde hız değişimi yoktur; sabit ivmeli harekette hız zamanla artar.',
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 3,
        name: 'Canlılarda Sistemler',
        topics: [
          {
            name: '1. Bölüm: Bitki ve Hayvanlarda Üreme, Büyüme ve Gelişme',
            videoLinks: ['https://www.youtube.com/watch?v=example9'],
            summary:
              'Bitkiler tohum, hayvanlar ise yumurta ve doğumla çoğalır; büyüme hormonlar ve çevresel faktörler tarafından yönlendirilir.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '2. Bölüm: Denetleyici ve Düzenleyici Sistemler',
            videoLinks: ['https://www.youtube.com/watch?v=example9'],
            summary:
              'Sinir ve hormonal sistemler organizmanın iç ve dış uyaranlara yanıt verir.',
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 4,
        name: 'Işığın Yansıması ve Renkler',
        topics: [
          {
            name: '1. Bölüm: Işığın Yansıması',
            videoLinks: ['https://www.youtube.com/watch?v=example10'],
            summary: 'Işık bir yüzeye çarptığında geri yönelir; bunun adı yansımadır.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '2. Bölüm: Aynalar',
            videoLinks: ['https://www.youtube.com/watch?v=example10'],
            summary:
              'Düz ve konkav/konveks aynalar farklı yansıma özelliklerine sahiptir.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '3. Bölüm: Işığın Soğurulması',
            videoLinks: ['https://www.youtube.com/watch?v=example10'],
            summary:
              'Bir madde ışığı absorbe edebilir; renklerin oluşumu bu süreçle ilişkilidir.',
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 5,
        name: 'Maddenin Ayırt Edici Özellikleri',
        topics: [
          {
            name: '1. Bölüm: Genleşme ve Büzülme',
            videoLinks: ['https://www.youtube.com/watch?v=example7'],
            summary:
              'Maddenin sıcaklığa bağlı olarak genişleyip daralması.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '2. Bölüm: Maddenin Hâl Değişim Noktaları',
            videoLinks: ['https://www.youtube.com/watch?v=example7'],
            summary:
              'Katı, sıvı, gaz hallerine geçişler ve ilgili enerji değişimleri.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '3. Bölüm: Yoğunluk',
            videoLinks: ['https://www.youtube.com/watch?v=example7'],
            summary:
              'Birim hacimdeki kütle miktarı, madde özelliklerini belirler.',
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 6,
        name: 'Elektiriğin İletimi ve Direnç',
        topics: [
          {
            name: '1. Bölüm: Elektriğin İletimi',
            videoLinks: ['https://www.youtube.com/watch?v=example7'],
            summary:
              'Elektrik akımı iletken maddelerde hareket eder.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '2. Bölüm: Elektriksel Direnç ve Bağlı Olduğu Faktörler',
            videoLinks: ['https://www.youtube.com/watch?v=example7'],
            summary:
              'Direnç, devrede akımın akışını sınırlayan bir özelliktir.',
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 7,
        name: 'Sürdürülebilir Yaşam Etkileşimi',
        topics: [
          {
            name: '1. Bölüm: Biyoçeşitlilik',
            videoLinks: ['https://www.youtube.com/watch?v=example7'],
            summary:
              'Canlıların çeşitliliği ekosistem sağlığı için kritiktir.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '2. Bölüm: İnsan ve Çevre Etkileşimi',
            videoLinks: ['https://www.youtube.com/watch?v=example7'],
            summary:
              'İnsan faaliyetleri doğa üzerinde etkili olur; sürdürülebilirlik önemlidir.',
            games: [],
            hasQuiz: true,
          },
        ],
      },
    ],
  },
  {
    grade: '7',
    title: '7. Sınıf Fen Bilimleri',
    color: 'from-teal-500 to-emerald-500',
    icon: 'ri-flask-line',
    image:
      'https://images.unsplash.com/photo-1507413245164-6160d8298b31?auto=format&fit=crop&q=80&w=800',
    units: [
      {
        id: 1,
        name: 'Güneş Sistemi ve Ötesi',
        topics: [
          {
            name: '1.Uzay Araştırmaları',
            videoLinks: ['https://www.youtube.com/watch?v=example11'],
            summary: 'Evren milyarlarca galaksiden oluşur. Samanyolu bizim galaksimizdir.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '2.Güneş Sistemi Ötesi:Gök Cisimleri',
            videoLinks: ['https://www.youtube.com/watch?v=example11'],
            summary: 'Evren milyarlarca galaksiden oluşur. Samanyolu bizim galaksimizdir.',
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 2,
        name: 'Hücre ve Bölünmeler',
        topics: [
          {
            name: '1.Hücre',
            videoLinks: ['https://www.youtube.com/watch?v=example12'],
            summary:
              'Mitoz, vücut hücrelerinin bölünme şeklidir. Büyüme ve yenilenme için gereklidir.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '2.Mitoz Bölünme',
            videoLinks: ['https://www.youtube.com/watch?v=example12'],
            summary:
              'Mitoz, vücut hücrelerinin bölünme şeklidir. Büyüme ve yenilenme için gereklidir.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '3.Mayoz Bölünme',
            videoLinks: ['https://www.youtube.com/watch?v=example12'],
            summary:
              'Mitoz, vücut hücrelerinin bölünme şeklidir. Büyüme ve yenilenme için gereklidir.',
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 3,
        name: 'Kuvvet ve Enerji',
        topics: [
          {
            name: '1.Kütle ve Ağırlık İlişkisi',
            videoLinks: ['https://www.youtube.com/watch?v=example13'],
            summary:
              'Enerji bir türden başka bir türe dönüşebilir ancak yok olmaz.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '2.Kuvvet, İş ve Enerji İlişkisi',
            videoLinks: ['https://www.youtube.com/watch?v=example13'],
            summary:
              'Enerji bir türden başka bir türe dönüşebilir ancak yok olmaz.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '3.Enerji Dönüşümleri',
            videoLinks: ['https://www.youtube.com/watch?v=example13'],
            summary:
              'Enerji bir türden başka bir türe dönüşebilir ancak yok olmaz.',
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 4,
        name: 'Saf Madde ve Karışımlar',
        topics: [
          {
            name: '1.Maddeinin Tanecikli Yapısı',
            videoLinks: ['https://www.youtube.com/watch?v=example14'],
            summary:
              'Karışımlar süzme, damıtma, kristallendirme gibi yöntemlerle ayrılabilir.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '2.Saf Maddeler',
            videoLinks: ['https://www.youtube.com/watch?v=example14'],
            summary:
              'Karışımlar süzme, damıtma, kristallendirme gibi yöntemlerle ayrılabilir.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '3.Karışımlar',
            videoLinks: ['https://www.youtube.com/watch?v=example14'],
            summary:
              'Karışımlar süzme, damıtma, kristallendirme gibi yöntemlerle ayrılabilir.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '4.Karışımların Ayrılması',
            videoLinks: ['https://www.youtube.com/watch?v=example14'],
            summary:
              'Karışımlar süzme, damıtma, kristallendirme gibi yöntemlerle ayrılabilir.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '5.Evsel Atıklar ve Geri Dönüşüm',
            videoLinks: ['https://www.youtube.com/watch?v=example14'],
            summary:
              'Karışımlar süzme, damıtma, kristallendirme gibi yöntemlerle ayrılabilir.',
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 5,
        name: 'Işığın Madde ile Etkileşimi',
        topics: [
          {
            name: '1.Işığın Soğrulması',
            videoLinks: ['https://www.youtube.com/watch?v=example13'],
            summary:
              'Enerji bir türden başka bir türe dönüşebilir ancak yok olmaz.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '2.Aynalar',
            videoLinks: ['https://www.youtube.com/watch?v=example13'],
            summary:
              'Enerji bir türden başka bir türe dönüşebilir ancak yok olmaz.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '3.Işığın Kırılması ve Mercekler',
            videoLinks: ['https://www.youtube.com/watch?v=example13'],
            summary:
              'Enerji bir türden başka bir türe dönüşebilir ancak yok olmaz.',
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 6,
        name: 'Canlılarda Üreme, Büyüme ve Gelişme',
        topics: [
          {
            name: '1.İnsanda Üreme, Büyüme ve Gelişme',
            videoLinks: ['https://www.youtube.com/watch?v=example13'],
            summary:
              'Enerji bir türden başka bir türe dönüşebilir ancak yok olmaz.',
            games: [],
            hasQuiz: true,
          },
          {
            name: '2.Bitki ve Hayvanlarda Üreme, Büyüme ve Gelişme',
            videoLinks: ['https://www.youtube.com/watch?v=example13'],
            summary:
              'Enerji bir türden başka bir türe dönüşebilir ancak yok olmaz.',
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 7,
        name: 'Elektrik Devreleri',
        topics: [
          {
            name: '1.Ampullerin Bağlanma Şekilleri',
            videoLinks: ['https://www.youtube.com/watch?v=example13'],
            summary:
              'Enerji bir türden başka bir türe dönüşebilir ancak yok olmaz.',
            games: [],
            hasQuiz: true,
          },
        ],
      },
    ],
  },
  {
    grade: '8',
    title: '8. Sınıf Fen Bilimleri',
    color: 'from-purple-500 to-pink-500',
    icon: 'ri-reactjs-line',
    image:
      'https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?auto=format&fit=crop&q=80&w=800',
    units: [
      {
        id: 1,
        name: 'Mevsimler ve İklim',
        topics: [
          {
            name: '1.Mevsimlerin Oluşumu',
            videoLinks: ['https://www.youtube.com/watch?v=example15'],
            summary: "Mevsimlerin oluşumu, Dünya'nın hareketleri ve eksen eğikliği incelenir.",
            kazanimKonu: "Konu / Kavramlar: Dünya'nın dönme ekseni, dolanma düzlemi, ısı enerjisi, mevsimler",
            kazanimDetay: "F.8.1.1.1. Mevsimlerin oluşumuna yönelik tahminlerde bulunur.\n\na. Dünya'nın dönme ekseni olduğuna değinilir.\nb. Dünya'nın dönme ekseni ile Güneş etrafındaki dolanma düzlemi arasındaki ilişkiye değinilir.\nc. Işığın birim yüzeye düşen enerji miktarının mevsimler üzerindeki etkisine değinilir.",
            games: [],
            hasQuiz: true,
          },
          {
            name: '2.İklim ve Hava Hareketleri',
            videoLinks: ['https://www.youtube.com/watch?v=example15'],
            summary:
              'Küresel ısınma, sera gazlarının artmasıyla oluşan iklim değişikliğidir.',
            kazanimKonu: "Konu / Kavramlar: İklim, iklim bilimi, iklim bilimci, küresel iklim değişikliği",
            kazanimDetay: `F.8.1.2.1. İklim ve hava olayları arasındaki farkı açıklar.
F.8.1.2.2. İklim biliminin (klimatoloji) bir bilim dalı olduğunu ve bu alanda çalışan uzmanlara iklim bilimci (klimatolog) adı verildiğini söyler.`,
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 2,
        name: 'DNA ve Genetik Kod',
        topics: [
          {
            name: '1.DNA ve Genetik Kod',
            videoLinks: ['https://www.youtube.com/watch?v=example16'],
            summary:'Canlılığın şifresi DNA\'nın yapısını, genetik kodları ve kendini eşleme sürecini keşfedin.',
            kazanimKonu: 'Konu / Kavramlar: DNA’nın yapısı, DNA’nın kendini eşlemesi, nükleotid, gen, kromozom',
            kazanimDetay: `F.8.2.1.1. Nükleotid, gen, DNA ve kromozom kavramlarını açıklayarak bu kavramlar arasında ilişki kurar. Bazların isimleri verilirken pürin ve pirimidin ayrımına girilmez.
F.8.2.1.2. DNA’nın yapısını model üzerinde gösterir.
a. Hidrojen, glikozit, ester, fosfodiester bağlarına girilmez.
b. DNA’daki hataların onarılıp onarılmadığı belirtilir.
c. DNA’daki nükleotid hesaplamaları verilmez.
F.8.2.1.3. DNA’nın kendini nasıl eşlediğini ifade eder.
a. Replikasyon ifadesi kullanılmaz.
b. Eşlenme deneyleri anlatılmaz.
c. Eşlenme ile ilgili hesaplama sorularına girilmez.`,
            games: [],
            hasQuiz: true,
          },
          {
            name: '2.Kalıtım',
            videoLinks: ['https://www.youtube.com/watch?v=example16'],
           summary: 'Genetik özelliklerin nesilden nesile nasıl aktarıldığını, Mendel çaprazlamalarını ve cinsiyetin belirlenme sürecini keşfedin.',
           kazanimKonu: 'Konu / Kavramlar: Gen, genotip, fenotip, saf döl, melez döl, baskın, çekinik, çaprazlama, cinsiyet, akraba evlilikleri',
          kazanimDetay: `F.8.2.2.1. Kalıtım ile ilgili kavramları tanımlar.
a. Gen, fenotip, genotip, saf döl ve melez döl kavramlarına değinilir.
b. Baskın ve çekinik gen kavramlarına değinilir.
F.8.2.2.2. Tek karakter çaprazlamaları ile ilgili problemler çözerek sonuçlar hakkında yorum yapar.
a. Çaprazlamalarda sadece bezelye karakterleri kullanılır.
b. Diğer canlılarda da karakterlerin aktarımının benzer olduğu vurgulanır.
c. İnsanda çocuğun cinsiyetinin babadan gelen eşey kromozomu ile belirlendiği vurgulanır.
F.8.2.2.3. Akraba evliliklerinin genetik sonuçlarını tartışır.`, 
            games: [],
            hasQuiz: true,
          },
          {
            name: '3.Mutasyon ve Modifikasyon',
            videoLinks: ['https://www.youtube.com/watch?v=example16'],
            summary:'Genetik yapıda meydana gelen ani değişimler (mutasyon) ile çevre etkisiyle oluşan geçici değişimleri (modifikasyon) ve aralarındaki kritik farkları keşfedin.',
            kazanimKonu: 'Konu / Kavramlar: Mutasyon, modifikasyon',
          kazanimDetay: `F.8.2.3.1. Örneklerden yola çıkarak mutasyonu açıklar.
F.8.2.3.2. Örneklerden yola çıkarak modifikasyonu açıklar.
F.8.2.3.3. Mutasyonla modifikasyon arasındaki farklar ile ilgili çıkarımda bulunur.`,
            games: [],
            hasQuiz: true,
          },
          {
            name: '4.Adaptasyon',
            videoLinks: ['https://www.youtube.com/watch?v=example16'],
            summary: 'Canlıların hayatta kalma şansını artıran kalıtsal uyum süreçlerini (adaptasyon), doğal seçilimi ve tür içi çeşitliliği (varyasyon) keşfedin.',
            kazanimKonu: 'Konu / Kavramlar: Adaptasyon, doğal seçilim, varyasyon',
          kazanimDetay: `F.8.2.4.1. Canlıların yaşadıkları çevreye uyumlarını gözlem yaparak açıklar.
Adaptasyonların kalıtsal olduğu vurgulanır.`,
            games: [],
            hasQuiz: true,
          },
          {
            name: '5.Bioteknoloji',
            videoLinks: ['https://www.youtube.com/watch?v=example16'],
            summary: 'Genetik mühendisliği ve biyoteknolojinin dünyasını, yapay seçilimi, klonlamayı ve bu teknolojilerin insanlık için yarattığı fırsatlar ile etik ikilemleri keşfedin.',
            kazanimKonu: 'Konu / Kavramlar: Genetik mühendisliği, yapay seçilim, biyoteknolojik çalışmalar, biyoteknoloji uygulamalarının çevreye etkisi',
          kazanimDetay: `F.8.2.5.1. Genetik mühendisliğini ve biyoteknolojiyi ilişkilendirir.
Islah, aşılama, gen aktarımı, klonlama, gen tedavisi örnekleri üzerinde durulur.
F.8.2.5.2. Biyoteknolojik uygulamalar kapsamında oluşturulan ikilemlerle bu uygulamaların insanlık için yararlı ve zararlı yönlerini tartışır.
F.8.2.5.3. Gelecekteki genetik mühendisliği ve biyoteknoloji uygulamalarının neler olabileceği hakkında tahminde bulunur.`,
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 3,
        name: 'Basınç',
        topics: [
          {
            name: '1.Basıncı',
            videoLinks: ['https://www.youtube.com/watch?v=example17'],
            summary: 'Katı, sıvı ve gaz basıncını, Pascal prensibini ve günlük yaşamdaki uygulamalarını keşfedin.',
            kazanimKonu: 'Konu / Kavramlar: Basınç, katı basıncını etkileyen değişkenler, sıvı basıncını etkileyen değişkenler, basıncın günlük yaşam ve teknolojideki uygulamaları',
          kazanimDetay: `F.8.3.1.1. Katı basıncını etkileyen değişkenleri deneyerek keşfeder.
Basınç birimi olarak Pascal verilir. Matematiksel bağıntılara girilmez.
F.8.3.1.2. Sıvı basıncını etkileyen değişkenleri tahmin eder ve tahminlerini test eder.
a. Gazların da sıvılara benzer şekilde basınç uyguladıkları belirtilir. Açık hava basıncı örneklendirilir.
b. Matematiksel bağıntılara girilmez.
c. Gaz basıncını etkileyen değişkenlere girilmez.
F.8.3.1.3. Katı, sıvı ve gazların basınç özelliklerinin günlük yaşam ve teknolojideki uygulamalarına örnekler verir.
a. Sıvı basıncı ile ilgili Pascal prensibinin uygulamalarından örnekler verilir.
b. Bilimsel bilgi türü olarak ilke ve prensiplere vurgu yapılır.`,
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 4,
        name: 'Madde ve Endüstri',
        topics: [
          {
            name: '1.Periyodik Sistem',
            videoLinks: ['https://www.youtube.com/watch?v=example18'],
            summary:
              'Elementlerin dünyasını düzenleyen periyodik sistemi, grup ve periyotları, metal, ametal ve yarı metallerin yerini keşfedin.',
            kazanimKonu: 'Konu / Kavramlar: Grup, periyot, periyodik sistemin sınıflandırılması',
          kazanimDetay: `F.8.4.1.1. Periyodik sistemde, grup ve periyotların nasıl oluşturulduğunu açıklar.
Periyodik sisteme duyulan ihtiyaç ve periyodik sistemin oluşturulma süreci ayrıntıya girilmeden vurgulanır.
F.8.4.1.2. Elementleri periyodik tablo üzerinde metal, yarımetal ve ametal olarak sınıflandırır.
a. Elementlerin özelliklerine girilmez.
b. Soygazların üzerinde durulur.`,
            games: [
              {
                name: 'Periyodik Tablo Oyunu',
                url: 'https://helmer06-oss.github.io/periyodiktablooyunu/element_oyunu4.html',
              },
            ],
            hasQuiz: true,
          },
          {
            name: 'Fiziksel ve Kimyasal Değişimler',
            videoLinks: ['https://www.youtube.com/watch?v=example22'],
            summary:
              'Maddenin dış görünüşündeki fiziksel değişimler ile iç yapısını değiştiren kimyasal değişimleri ve farklarını keşfedin.',
            kazanimKonu: 'Konu / Kavramlar: Fiziksel değişim, kimyasal değişim',
          kazanimDetay: `F.8.4.2.1. Fiziksel ve kimyasal değişim arasındaki farkları, çeşitli olayları gözlemleyerek açıklar.`,
            games: [],
            hasQuiz: true,
          },
          {
            name: 'Kimyasal Tepkimeler',
            videoLinks: ['https://www.youtube.com/watch?v=example23'],
            summary:
              'Atomların bağ yapısını değiştirerek yeni maddelere dönüştüğü kimyasal tepkimeleri ve kütlenin korunumu yasasını keşfedin.',
            kazanimKonu: 'Konu / Kavramlar: Kimyasal tepkimelerin oluşumu, kütlenin korunumu',
          kazanimDetay: `F.8.4.3.1. Bileşiklerin kimyasal tepkime sonucunda oluştuğunu bilir.
Kimyasal tepkime denklemlerine formüller kullanılarak girilmez.`,
            games: [],
            hasQuiz: true,
          },
          {
            name: 'Asitler ve Bazlar',
            videoLinks: ['https://www.youtube.com/watch?v=example24'],
            summary:
              'Asit ve bazların özelliklerini, pH kavramını, günlük hayattaki yerlerini, ayraçları ve asit yağmurlarının etkilerini keşfedin.',
            kazanimKonu: 'Konu / Kavramlar: Asit, baz, pH, asit yağmurları, asit yağmurlarına karşı çözüm önerileri',
          kazanimDetay: `F.8.4.4.1. Asit ve bazların genel özelliklerini ifade eder.
F.8.4.4.2. Asit ve bazlara günlük yaşamdan örnekler verir.
F.8.4.4.3. Günlük hayatta ulaşılabilecek malzemeleri asit-baz ayracı olarak kullanır.
F.8.4.4.4. Maddelerin asitlik ve bazlık durumlarına ilişkin pH değerlerini kullanarak çıkarımda bulunur. Konu ile ilgili deney yolu ile çıkarımlarda bulunmaları sağlanır.
F.8.4.4.5. Asit ve bazların çeşitli maddeler üzerindeki etkilerini gözlemler.
F.8.4.4.6. Asit ve bazların temizlik malzemesi olarak kullanılması esnasında oluşabilecek tehlikelerle ilgili gerekli tedbirleri alır.
F.8.4.4.7. Asit yağmurlarının önlenmesine yönelik çözüm önerileri sunar.
Asit yağmurlarının oluşum sebepleri ve sonuçlarına değinilir.`,
            games: [],
            hasQuiz: true,
          },
          {
            name: 'Maddenin Isı ile Etkileşimi',
            videoLinks: ['https://www.youtube.com/watch?v=example25'],
            summary:
              'Isı, sıcaklık ve öz ısı kavramlarını, hal değişim süreçlerini ve ısınma-soğuma grafiklerini yorumlamayı keşfedin.',
            kazanimKonu: 'Konu / Kavramlar: Isı ve öz ısının bağlı olduğu faktörler',
          kazanimDetay: `F.8.4.5.1. Isınmanın maddenin cinsine, kütlesine ve/veya sıcaklık değişimine bağlı olduğunu deney yaparak keşfeder.
a. Q=m.c. Δt bağıntısına girilmez.
b. Bağımlı, bağımsız ve kontrol edilen değişkenler örneklerle açıklanır.
F.8.4.5.2. Hâl değiştirmek için gerekli ısının maddenin cinsi ve kütlesiyle ilişkili olduğunu deney yaparak keşfeder.
a. Saf maddelerin hâl değişimi sırasında sıcaklığının sabit kaldığına değinilir.
b. Matematiksel hesaplamalara girilmez.
F.8.4.5.3. Maddelerin hâl değişimi ve ısınma grafiğini çizerek yorumlar.
F.8.4.5.4. Günlük yaşamda meydana gelen hâl değişimleri ile ısı alışverişini ilişkilendirir.`,
            games: [],
            hasQuiz: true,
          },
          {
            name: "Türkiye'de Kimya Endüstrisi",
            videoLinks: ['https://www.youtube.com/watch?v=example26'],
            summary:
              'Türkiye\'deki kimya endüstrisinin gelişimini, ithalat-ihracat ürünlerini, ilgili kurumları ve kimya alanındaki meslekleri keşfedin.',
            kazanimKonu: 'Konu / Kavramlar: İthal edilen kimyasal ürünler, ihraç edilen kimyasal ürünler, ülkemizdeki kimya endüstrisinin gelişimine katkı sağlayan resmî/özel kurumlar, kimya temelli meslekler',
          kazanimDetay: `F.8.4.6.1. Geçmişten günümüze Türkiye’deki kimya endüstrisinin gelişimini araştırır.
a. Ülkemizdeki kimya endüstrisinin gelişimine katkı sağlayan resmi / özel kurum ve sivil toplum kuruluşlarının yaptığı çalışmalara değinilir.
b. İthal ve ihraç edilen kimyasal ürünlerden birkaç önemli örnek verilerek Türkiye kimya endüstrisinin işleyişine değinilir.
F.8.4.6.2. Kimya endüstrisinde meslek dallarını araştırır ve gelecekteki yeni meslek alanları hakkında öneriler sunar.`,
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 5,
        name: 'Basit Makinalar',
        topics: [
          {
            name: '1.Basit Makineler',
            videoLinks: ['https://www.youtube.com/watch?v=example19'],
            summary:
              'İş yapma kolaylığı sağlayan makaralar, kaldıraçlar ve eğik düzlem gibi basit makineleri ve çalışma prensiplerini keşfedin.',
            kazanimKonu: 'Konu / Kavramlar: Sabit makara, hareketli makara, palanga, kaldıraç, eğik düzlem, çıkrık, basit makinelerin kullanım alanları',
          kazanimDetay: `F.8.5.1.1. Basit makinelerin sağladığı avantajları örnekler üzerinden açıklar.
a. Basit makinelerden, sabit makara, hareketli makara, palanga, kaldıraç, eğik düzlem ve çıkrık üzerinde durulur.
b. Dişli çarklar, vida ve kasnakların da birer basit makine olduğu görsellerle belirtilir, ayrıntıya girilmez.
c. Basit makinelerde işten kazanç olmadığı vurgulanır.
ç. Matematiksel bağıntılara girilmez.
F.8.5.1.2. Basit makinelerden yararlanarak günlük yaşamda iş kolaylığı sağlayacak bir düzenek tasarlar. Öncelikle tasarımını çizimle ifade etmesi istenir. Şartlar uygunsa üç boyutlu modele dönüştürmesi istenebilir.`,
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 6,
        name: 'Enerji Dönüşümleri ve Çevre Bilimi',
        topics: [
          {
            name: '1.Besin Zinciri ve Enerji Akışı',
            videoLinks: ['https://www.youtube.com/watch?v=example20'],
            summary:
              'Canlılar arasındaki beslenme ilişkilerini, besin zincirlerini, ekoloji piramidini ve enerji akışını keşfedin.',
            kazanimKonu: 'Konu / Kavramlar: Besin zinciri, besin ağı, üretici, tüketici, ayrıştırıcı, ekoloji piramidi, biyolojik birikim',
          kazanimDetay: `F.8.6.1.1. Besin zincirindeki üretici, tüketici, ayrıştırıcılara örnekler verir.
a. Parazit besin zincirlerine değinilmez.
b. Ekoloji piramitlerinde enerji aktarımı, vücut büyüklüğü, birey sayısı ve biyolojik birikim vurgulanır.`,
            games: [],
            hasQuiz: true,
          },
          {
            name: '2.Enerji Dönüşümleri',
            videoLinks: ['https://www.youtube.com/watch?v=example20'],
            summary:
              'Bitkilerin güneş ışığını besine dönüştürdüğü fotosentezi ve canlıların enerji üretmek için yaptığı solunum çeşitlerini keşfedin.',
            kazanimKonu: 'Konu / Kavramlar: Fotosentez, fotosentez hızını etkileyen faktörler, solunum, oksijensiz solunum, oksijenli solunum',
          kazanimDetay: `F.8.6.2.1. Bitkilerde besin üretiminde fotosentezin önemini fark eder.
a. Fotosentezde karbondioksit ve su kullanıldığı, besin ve oksijen üretildiği vurgulanır. Kimyasal denklemine girilmez.
b. Fotosentezin yapay ışıkta da meydana gelebileceği vurgulanır.
c. Fotosentez yapan canlıların üretici olduğu ifade edilir.
F.8.6.2.2. Fotosentez hızını etkileyen faktörler ile ilgili çıkarımlarda bulunur.
Işık rengi, karbondioksit miktarı, su miktarı, ışık şiddeti ve sıcaklık vurgulanır.
F.8.6.2.3. Canlılarda solunumun önemini belirtir.
a. Solunumun kimyasal denklemine girilmez.
b. Bitkilerin gece ve gündüz solunum yaptığına değinilir.
c. Oksijenli ve oksijensiz solunum evrelerine girilmeden verilir fakat açığa çıkan enerji miktarları sayısal olarak belirtilmez.
ç. ATP’nin yapısına girilmeden isminden bahsedilir.`,
            games: [],
            hasQuiz: true,
          },
          {
            name: '3.Madde Döngüleri ve Çevre Sorunları',
            videoLinks: ['https://www.youtube.com/watch?v=example20'],
            summary:
              'Doğadaki su, oksijen, azot ve karbon döngülerini, küresel ısınmayı, sera etkisini ve ekolojik ayak izi kavramını keşfedin.',
            kazanimKonu: 'Konu / Kavramlar: Su döngüsü, oksijen döngüsü, azot döngüsü, karbon döngüsü, ozon tabakası, küresel ısınma',
          kazanimDetay: `F.8.6.3.1. Madde döngülerini şema üzerinde göstererek açıklar.
F.8.6.3.2. Madde döngülerinin yaşam açısından önemini sorgular.
F.8.6.3.3. Küresel iklim değişikliklerinin nedenlerini ve olası sonuçlarını tartışır.
a. Sera etkisi açıklanır.
b. Küresel iklim değişikliği bağlamında çevre sorunlarının Dünya'nın geleceğine ve insan yaşamına nasıl bir etkisi olabileceği sorgulanır.
c. Çevre sorunlarının dünyanın geleceğine nasıl bir etkisinin olabileceğine yönelik öngörüleri sanatsal yollarla ifade etmeleri istenir.
ç. Öğrencilerin ekolojik ayak izini hesaplaması (uzantısı edu, org ve mil gibi güvenli sitelerden yararlanılabilinir) sağlanır.
d. Dünya ülkelerinin küresel iklim değişikliğini önlemek için aldıkları önlemlere (ör. Kyoto Protokolü) değinilir.`,
            games: [],
            hasQuiz: true,
          },
          {
            name: '4.Sürdürülebilir Kalkınma',
            videoLinks: ['https://www.youtube.com/watch?v=example20'],
            summary:
              'Gelecek nesillerin ihtiyaçlarını tehlikeye atmadan kaynakları verimli kullanmayı, geri dönüşümü ve sürdürülebilir yaşamı keşfedin.',
            kazanimKonu: 'Konu / Kavramlar: Sürdürülebilir yaşam, kaynakların tasarruflu kullanımı, geri dönüşüm',
          kazanimDetay: `F.8.6.4.1. Kaynakların kullanımında tasarruflu davranmaya özen gösterir.
F.8.6.4.2. Kaynakların tasarruflu kullanımına yönelik proje tasarlar.
F.8.6.4.3. Geri dönüşüm için katı atıkların ayrıştırılmasının önemini açıklar.
F.8.6.4.4. Geri dönüşümün ülke ekonomisine katkısına ilişkin araştırma verilerini kullanarak çözüm önerileri sunar.
F.8.6.4.5. Kaynakların tasarruflu kullanılmaması durumunda gelecekte karşılaşılabilecek problemleri belirterek çözüm önerileri sunar.`,
            games: [],
            hasQuiz: true,
          },
        ],
      },
      {
        id: 7,
        name: 'Elektrik Yükleri ve Elektrik Enerjisi',
        topics: [
          {
            name: '1.Elektrik Yükleri ve Elektriklenme',
            videoLinks: ['https://www.youtube.com/watch?v=example21'],
            summary:
              'Statik elektriği, yüklerin birbirini itip çekmesini ve teknolojideki elektriklenme uygulamalarını keşfedin.',
            kazanimKonu: 'Konu / Kavramlar: Elektrik yükleri, elektrik yükleri arasındaki itme ve çekme kuvvetleri, elektriklenme çeşitleri',
          kazanimDetay: `F.8.7.1.1. Elektriklenmeyi, bazı doğa olayları ve teknolojideki uygulama örnekleri ile açıklar.
F.8.7.1.2. Elektrik yüklerini sınıflandırarak aynı ve farklı cins elektrik yüklerinin birbirlerine etkisini açıklar.
F.8.7.1.3. Deneyler yaparak elektriklenme çeşitlerini fark eder.`,
            games: [],
            hasQuiz: true,
          },
          {
            name: '2.Elektrik Yüklü Cisimler',
            videoLinks: ['https://www.youtube.com/watch?v=example21'],
            summary:
              'Cisimlerin yük durumlarını (nötr, pozitif, negatif), yük tespiti yapan elektroskopu ve güvenliğimiz için hayati olan topraklamayı keşfedin.',
            kazanimKonu: 'Konu / Kavramlar: Pozitif yüklü cisim, negatif yüklü cisim, elektroskop, topraklama',
          kazanimDetay: `F.8.7.2.1. Cisimleri, sahip oldukları elektrik yükleri bakımından sınıflandırır.
Özellikle nötr cismin, yüksüz cisim anlamına gelmediği; nötr cisimlerde pozitif ve negatif yük miktarlarının eşit olduğu vurgusu yapılır. Elektroskopun yük ölçümünde kullanıldığı belirtilir, çalışma prensibine girilmez.
F.8.7.2.2. Topraklamayı açıklar.
Topraklamanın günlük yaşam ve teknolojideki uygulamaları dikkate alınarak can ve mal güvenliği açısından önemine vurgu yapılır.`,
            games: [],
            hasQuiz: true,
          },
          {
            name: '3.Elektrik Enerjisinin Dönüşümü',
            videoLinks: ['https://www.youtube.com/watch?v=example21'],
            summary:
              'Elektrik enerjisinin ısı, ışık ve harekete dönüşümünü, güç santrallerini ve enerji tasarrufunun önemini keşfedin.',
            kazanimKonu: 'Konu / Kavramlar: Elektrik enerjisinin ısı ve ışık enerjisine dönüşümü, elektrik enerjisinin hareket enerjisine ve hareket enerjisinin elektrik enerjisine dönüşümü, güç santralleri, elektrik enerjisinin bilinçli ve tasarruflu kullanımı',
          kazanimDetay: `F.8.7.3.1. Elektrik enerjisinin ısı, ışık ve hareket enerjisine dönüştüğü uygulamalara örnekler verir.
a. Güvenlik açısından elektrik sigortasının önemi üzerinde durulur.
b. Robotların, elektrik enerjisinin, hareket enerjisine dönüşümü temel alınarak geliştirildiği vurgulanır.
F.8.7.3.2. Elektirik enerjisinin ısı, ışık veya hareket enerjisine dönüşümü temel alan bir model tasarlar.
Öncelikle tasarımlarını çizimle ifade etmeleri istenir. Şartlar uygunsa üç boyutlu modele dönüştürmesi istenebilir.
F.8.7.3.3. Güç santrallerinde elektrik enerjisinin nasıl üretildiğini açıklar.
Güç santrallerinden hidroelektrik, termik, rüzgâr, jeotermal ve nükleer santrallere değinilir.
F.8.7.3.4. Güç santrallerinin avantaj ve dezavantajları konusunda fikirler üretir.
Güç santrallerinin yarar-zarar ve riskler yönünden değerlendirilmesine yönelik fikir üretmeleri ve bu fikirlerini savunmaları istenir.
F.8.7.3.5. Elektrik enerjisinin bilinçli ve tasarruflu kullanılmasının aile ve ülke ekonomisi bakımından önemini tartışır.
a. Enerji verimliliği konusunda ülkemizdeki resmî kurumlar ve sivil toplum kuruluşları tarafından yapılan çalışmalar ve elektrik enerjisi kullanımı bakımından yapılması gerekenler belirtilir.
b. Kaçak elektrik kullanımının ülke ekonomisine verdiği zarar vurgulanır.
F.8.7.3.6. Evlerde elektriği tasarruflu kullanmaya özen gösterir.
Öğrencilerden elektrik faturasını azaltmaya yönelik uzun süreli çalışmalar yapmaları istenir, süreç izlenir.`,
            games: [],
            hasQuiz: true,
          },
        ],
      },
    ],
  },
];

export default function NotesPage() {
  const [selectedGrade, setSelectedGrade] = useState<string | null>(null);
  const [selectedUnit, setSelectedUnit] = useState<number | null>(null);
  const [selectedTopic, setSelectedTopic] = useState<any>(null);

  const currentGradeData = educationStructure.find((g) => g.grade === selectedGrade);
  const currentUnit = currentGradeData?.units.find((u) => u.id === selectedUnit);

  const resetSelection = () => {
    setSelectedGrade(null);
    setSelectedUnit(null);
    setSelectedTopic(null);
  };
  // --- YENİ VE KESİN ÇÖZÜM: Parçalanmış Yapı --

  // 1. Sadece SINIF açılınca geçmişe ekle (Diğerlerini etkilemez)
  useEffect(() => {
    if (selectedGrade) {
      window.history.pushState(null, '');
    }
  }, [selectedGrade]);

  // 2. Sadece ÜNİTE açılınca geçmişe ekle
  useEffect(() => {
    if (selectedUnit) {
      window.history.pushState(null, '');
    }
  }, [selectedUnit]);

  // 3. Sadece KONU açılınca geçmişe ekle
  useEffect(() => {
    if (selectedTopic) {
      window.history.pushState(null, '');
    }
  }, [selectedTopic]);

  // 4. Geri Tuşuna Basılınca Ne Olsun? (Dinleyici)
  useEffect(() => {
    const handlePopState = () => {
      // Sırayla en derinden dışarı doğru kontrol et
      if (selectedTopic) {
        setSelectedTopic(null); // Konuyu kapat
      } else if (selectedUnit) {
        setSelectedUnit(null); // Üniteyi kapat
      } else if (selectedGrade) {
        setSelectedGrade(null); // Sınıfı kapat
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [selectedGrade, selectedUnit, selectedTopic]); // Her değişimde dinleyiciyi güncelle
  // ----------------------------------------------------
  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-teal-50/30 to-emerald-50/40" style={{ fontFamily: 'Poppins, sans-serif' }}>
      {/* Header */}
      {/* --- YENİ MODERN HERO BÖLÜMÜ BAŞLANGICI --- */}
      <div className="relative bg-slate-900 pb-20 overflow-hidden">
        
        {/* Arka Plan Efekti */}
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-900/30 via-slate-900/50 to-purple-900/30" />
          <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-700 to-transparent" />
        </div>

        {/* Navbar (Menü) */}
        <div className="relative z-50">
          <Navbar />
        </div>

        {/* İçerik Alanı (Başlıklar) */}
        {/* pt-32: Navbarın altına girmemesi için üstten boşluk bırakır */}
        <div className="relative z-10 container mx-auto px-4 pt-32 text-center">
          
          {/* Üstteki Gri Etiket (Badge) */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-800/80 border border-slate-700 backdrop-blur-sm mb-8">
            <span className="flex h-2 w-2 rounded-full bg-teal-400 animate-pulse"></span>
            <span className="text-sm font-medium text-slate-300 tracking-wide">
              Eğitim Kaynakları
            </span>
          </div>

          {/* Ana Başlık (Modern Kalın Font) */}
          <h1 className="text-5xl md:text-6xl font-black text-white tracking-tight mb-6">
            Ders Notları <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-emerald-400">Arşivi</span>
          </h1>

          {/* Alt Açıklama */}
          <p className="text-lg text-slate-400 max-w-2xl mx-auto leading-relaxed font-light">
            Fen Bilimleri konu anlatımları, özet bilgiler, eğitsel oyunlar, testler ve çalışma kağıtlarına buradan ulaşabilir, 
            ister PDF indirip ister online çalışabilirsin.
          </p>
        </div>
      </div>
      {/* --- YENİ MODERN HERO BÖLÜMÜ BİTİŞİ --- */}

{/* Mevcut içerik buradan devam edecek */}
{/* Not: Aşağıdaki "Breadcrumb" veya "Tüm Sınıflar" butonlarının olduğu kısım buradan sonra gelmeli */}
      {/* Breadcrumb Navigation */}
      {(selectedGrade || selectedUnit || selectedTopic) && (
        <div className="bg-white border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <div className="flex items-center gap-2 text-sm">
              <button onClick={resetSelection} className="text-teal-600 hover:text-teal-700 font-medium cursor-pointer">
                Tüm Sınıflar
              </button>
              {selectedGrade && (
                <>
                  <i className="ri-arrow-right-s-line text-gray-400"></i>
                  <button
                    onClick={() => {
                      setSelectedUnit(null);
                      setSelectedTopic(null);
                    }}
                    className="text-teal-600 hover:text-teal-700 font-medium cursor-pointer"
                  >
                    {currentGradeData?.title}
                  </button>
                </>
              )}
              {selectedUnit && (
                <>
                  <i className="ri-arrow-right-s-line text-gray-400"></i>
                  <button onClick={() => setSelectedTopic(null)} className="text-teal-600 hover:text-teal-700 font-medium cursor-pointer">
                    {currentUnit?.name}
                  </button>
                </>
              )}
              {selectedTopic && (
                <>
                  <i className="ri-arrow-right-s-line text-gray-400"></i>
                  <span className="text-gray-700 font-medium">{selectedTopic.name}</span>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Sınıf Seçimi */}
        {!selectedGrade && (
          <div>
            <div className="text-center mb-12">
                            

            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {educationStructure.map((grade) => (
                <div
                  key={grade.grade}
                  onClick={() => setSelectedGrade(grade.grade)}
                  className="group bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 cursor-pointer"
                >
                  <div className="relative h-48 w-full overflow-hidden">
                    <img src={grade.image} alt={grade.title} className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500" />
                    <div className={`absolute inset-0 bg-gradient-to-br ${grade.color} opacity-30 group-hover:opacity-40 transition-opacity duration-300`}></div>

                    <div className="absolute top-4 right-4 w-14 h-14 flex items-center justify-center rounded-2xl bg-white shadow-lg">
                      <i className={`${grade.icon} text-3xl text-teal-600`}></i>
                    </div>
                  </div>

                  <div className="p-6">
                    <h3 className="text-2xl font-bold text-gray-900 mb-2 group-hover:text-teal-600 transition-colors duration-300" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                      {grade.title}
                    </h3>
                    <p className="text-gray-600 text-sm mb-4">
                      {grade.units.length} Ünite • {grade.units.reduce((acc, unit) => acc + unit.topics.length, 0)} Konu
                    </p>
                    <div className="flex items-center justify-between text-teal-600 font-semibold">
                      <span>Konulara Git</span>
                      <i className="ri-arrow-right-line group-hover:translate-x-2 transition-transform"></i>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Ünite Seçimi */}
        {selectedGrade && !selectedUnit && currentGradeData && (
          <div>
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                {currentGradeData.title}
              </h2>
              <p className="text-gray-600">Bir ünite seçerek konulara ulaşabilirsiniz</p>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              {currentGradeData.units.map((unit) => (
                <div
                  key={unit.id}
                  onClick={() => setSelectedUnit(unit.id)}
                  className="group bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer border-2 border-transparent hover:border-teal-500"
                >
                  <div className="flex items-start gap-4">
                    <div className={`w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br ${currentGradeData.color} text-white font-bold text-lg flex-shrink-0`}>
                      {unit.id}
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-600 transition-colors">{unit.name}</h3>
                      <p className="text-gray-600 text-sm mb-3">{unit.topics.length} Konu</p>
                      <div className="flex flex-wrap gap-2">
                        {unit.topics.slice(0, 3).map((topic, idx) => (
                          <span key={idx} className="px-3 py-1 bg-teal-50 text-teal-700 rounded-full text-xs font-medium">
                            {topic.name}
                          </span>
                        ))}
                        {unit.topics.length > 3 && (
                          <span className="px-3 py-1 bg-gray-100 text-gray-600 rounded-full text-xs font-medium">
                            +{unit.topics.length - 3} daha
                          </span>
                        )}
                      </div>
                    </div>
                    <i className="ri-arrow-right-line text-2xl text-gray-400 group-hover:text-teal-600 group-hover:translate-x-2 transition-all"></i>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Konu Listesi */}
        {selectedGrade && selectedUnit && !selectedTopic && currentUnit && (
          <div>
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                {currentUnit.name}
              </h2>
              <p className="text-gray-600">Öğrenmek istediğiniz konuyu seçin</p>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              {currentUnit.topics.map((topic, idx) => (
                <div
                  key={idx}
                  onClick={() => setSelectedTopic(topic)}
                  className="group bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-500 hover:-translate-y-2 cursor-pointer"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br from-teal-500 to-emerald-500 text-white mb-4">
                    <i className="ri-book-2-line text-2xl"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">{topic.name}</h3>
                  <div className="flex flex-wrap gap-2 mb-4">
                    {topic.videoLinks.length > 0 && (
                      <span className="flex items-center gap-1 px-2 py-1 bg-red-50 text-red-600 rounded-lg text-xs font-medium">
                        <i className="ri-youtube-line"></i>
                        {topic.videoLinks.length} Video
                      </span>
                    )}
                    {topic.games.length > 0 && (
                      <span className="flex items-center gap-1 px-2 py-1 bg-purple-50 text-purple-600 rounded-lg text-xs font-medium">
                        <i className="ri-gamepad-line"></i>
                        {topic.games.length} Oyun
                      </span>
                    )}
                    {topic.hasQuiz && (
                      <span className="flex items-center gap-1 px-2 py-1 bg-emerald-50 text-emerald-600 rounded-lg text-xs font-medium">
                        <i className="ri-file-list-3-line"></i>
                        Test
                      </span>
                    )}
                  </div>
                  <p className="text-gray-600 text-sm line-clamp-2">{topic.summary}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Konu Detayı */}
        {selectedTopic && (
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-3xl shadow-xl overflow-hidden">
              {/* Header */}
              <div className={`bg-gradient-to-r ${currentGradeData?.color} p-8 text-white`}>
                <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                  {selectedTopic.name}
                </h1>
                <p className="text-white/90">
                  {currentGradeData?.title} • {currentUnit?.name}
                </p>
              </div>

              {/* Content */}
              <div className="p-8 space-y-8">
                {/* Kazanımlar */}
                {selectedTopic.kazanimKonu && (
                  <div>
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-teal-100">
                        <i className="ri-file-text-line text-xl text-teal-600"></i>
                      </div>
                      <h3 className="text-2xl font-bold text-gray-900">Kazanımlar</h3>
                    </div>
                    <div className="bg-teal-50 rounded-2xl p-6 space-y-4">
                      <div className="text-gray-700 text-lg leading-relaxed">
                        <div className="font-bold italic text-gray-500 mb-3 border-b pb-2">
                          {selectedTopic.kazanimKonu}
                        </div>
                        <div className="whitespace-pre-wrap text-gray-800 font-medium pl-2">
                          {selectedTopic.kazanimDetay || selectedTopic.kazanimlar}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Konu Anlatımı Videoları */}
                {selectedTopic.videoLinks.length > 0 && (
                  <div>
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-red-100">
                        <i className="ri-youtube-line text-xl text-red-600"></i>
                      </div>
                      <h3 className="text-2xl font-bold text-gray-900">Konu Anlatımı</h3>
                    </div>
                    <div className="space-y-3">
                      {selectedTopic.videoLinks.map((link: string, idx: number) => (
                        <a
                          key={idx}
                          href={link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center gap-4 p-4 bg-white border-2 border-gray-200 rounded-xl hover:border-red-500 hover:shadow-lg transition-all cursor-pointer group"
                        >
                          <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-red-50 group-hover:bg-red-100 transition-colors">
                            <i className="ri-play-circle-line text-2xl text-red-600"></i>
                          </div>
                          <div className="flex-1">
                            <p className="font-semibold text-gray-900 group-hover:text-red-600 transition-colors">
                              Video {idx + 1}
                            </p>
                            <p className="text-sm text-gray-500">YouTube'da izle</p>
                          </div>
                          <i className="ri-external-link-line text-gray-400 group-hover:text-red-600 transition-colors"></i>
                        </a>
                      ))}
                    </div>
                  </div>
                )}

                {/* Eğitsel Oyunlar */}
                {selectedTopic.games.length > 0 && (
                  <div>
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-purple-100">
                        <i className="ri-gamepad-line text-xl text-purple-600"></i>
                      </div>
                      <h3 className="text-2xl font-bold text-gray-900">Eğitsel Oyunlar</h3>
                    </div>
                    <div className="grid md:grid-cols-2 gap-4">
                      {selectedTopic.games.map((game: any, idx: number) => (
                        <a
                          key={idx}
                          href={game.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center gap-4 p-4 bg-gradient-to-br from-purple-50 to-pink-50 border-2 border-purple-200 rounded-xl hover:border-purple-500 hover:shadow-lg transition-all cursor-pointer group"
                        >
                          <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-white shadow-sm">
                            <i className="ri-gamepad-fill text-2xl text-purple-600"></i>
                          </div>
                          <div className="flex-1">
                            <p className="font-semibold text-gray-900 group-hover:text-purple-600 transition-colors">{game.name}</p>
                            <p className="text-sm text-gray-500">Oyna ve öğren</p>
                          </div>
                          <i className="ri-external-link-line text-gray-400 group-hover:text-purple-600 transition-colors"></i>
                        </a>
                      ))}
                    </div>
                  </div>
                )}

                {/* Test/Quiz */}
                {selectedTopic.hasQuiz && (
                  <div>
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-emerald-100">
                        <i className="ri-file-list-3-line text-xl text-emerald-600"></i>
                      </div>
                      <h3 className="text-2xl font-bold text-gray-900">Test Çöz</h3>
                    </div>
                    <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl p-6 border-2 border-emerald-200">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="font-semibold text-gray-900 mb-1">Konuyu Pekiştir</p>
                          <p className="text-sm text-gray-600">10 soruluk test ile bilgini ölç</p>
                        </div>
                        <button className="px-6 py-3 bg-gradient-to-r from-emerald-500 to-teal-500 text-white rounded-xl font-semibold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer">
                          Teste Başla
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <footer className="bg-slate-800 text-white py-12 px-4 mt-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-xl flex items-center justify-center">
                  <i className="ri-book-open-line text-xl text-white"></i>
                </div>
                <span className="text-xl font-bold">EduPlatform</span>
              </Link>
              <p className="text-gray-300 text-sm leading-relaxed mb-4">
                20+ yıllık deneyimimizle öğrencilerimize en kaliteli eğitimi sunuyoruz. Fen Bilimleri alanında uzmanlaşmış kadromuzla başarıya ulaşın.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Hızlı Linkler</h4>
              <div className="space-y-2 text-sm">
                <Link to="/" className="block text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Ana Sayfa
                </Link>
                <Link to="/notes" className="block text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Eğitim Materyalleri
                </Link>
                <Link to="/auth/login" className="block text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Giriş Yap
                </Link>
                <Link to="/auth/register" className="block text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Kayıt Ol
                </Link>
              </div>
            </div>

            <div>
              <h4 className="font-semibold mb-4">İletişim</h4>
              <div className="space-y-2 text-sm text-gray-300">
                <div className="flex items-center gap-2">
                  <i className="ri-phone-line"></i>
                  <span>+90 555 123 45 67</span>
                </div>

                <div className="flex items-center gap-2">
                  <i className="ri-mail-line"></i>
                  <span>info@eduplatform</span>
                </div>

                <div className="flex items-center gap-2">
                  <i className="ri-map-pin-line"></i>
                  <span>İstanbul</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-6 flex flex-col md:flex-row items-center justify-between">
            <p className="text-gray-300 text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>
              © 2025 Tolga AYDOS. Tüm hakları saklıdır.
            </p>
            <div className="flex items-center gap-6">
              <a
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-gray-300 hover:text-white text-sm transition-colors duration-300 cursor-pointer"
                style={{ fontFamily: 'Poppins, sans-serif' }}
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}